import { Pipe, PipeTransform } from '@angular/core';
import { FilterOption } from '@app/models/courses/filterOption.model';

@Pipe({
  name: 'valuesFilter'
})
export class FilterValuesPipe implements PipeTransform {
  transform(options: FilterOption[], name: any): any {
    if (options == null) {
      return null;
    }

    return options.filter(
      opt =>
        opt.values.filter(val => val.value.toLowerCase().includes(name.toLowerCase())).length > 0
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/course-areas/pipes/filter-values.pipe.ts